import { render, staticRenderFns } from "./ShopeeEdit.vue?vue&type=template&id=139c9de7&scoped=true"
import script from "./ShopeeEdit.vue?vue&type=script&lang=js"
export * from "./ShopeeEdit.vue?vue&type=script&lang=js"
import style0 from "./ShopeeEdit.vue?vue&type=style&index=0&id=139c9de7&prod&scoped=true&lang=css"
import style1 from "./ShopeeEdit.vue?vue&type=style&index=1&id=139c9de7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139c9de7",
  null
  
)

export default component.exports